// @ts-ignore
import toHTML from '@starptech/prettyhtml-hast-to-html';
export const generator = (htmlObject) => {
    return toHTML(htmlObject);
};
//# sourceMappingURL=html-to-string.js.map